/**
 * V4 Dashboard - Main Entry Point
 * Timeline and Summary implementation with filters
 */

import { Container, Typography, Box } from '@mui/material'
import { DashboardQueryProvider } from './query-provider'
import { useFilters } from './hooks/use-filters'
import FilterPanel from './components/filters/filter-panel'
import FilterSummary from './components/filters/filter-summary'
import TimelineTab from './components/timeline/timeline-tab'
import SummaryTab from './components/summary/summary-tab'
import AnalyticsTab from './components/analytics/analytics-tab'
import ExportTab from './components/export/export-tab'

function V4DashboardContent() {
  let filterState = useFilters()

  return (
    <Container maxWidth="xl" sx={{ py: 4 }}>
      {/* Header */}
      <Box sx={{ mb: 4 }}>
        <Typography variant="h4">Manager Dashboard</Typography>
      </Box>
      {/* Filter Panel */}
      <FilterPanel filterState={filterState} />
      {/* Filter Summary */}
      <FilterSummary filterState={filterState} />
      {/* Tab Content - driven by filter viewMode */}
      {filterState.filters.viewMode === 'summary' && (
        <SummaryTab queryParams={filterState.queryParams} />
      )}
      {filterState.filters.viewMode === 'timeline' && (
        <TimelineTab filterState={filterState} />
      )}
      {filterState.filters.viewMode === 'analytics' && (
        <AnalyticsTab queryParams={filterState.queryParams} />
      )}
      {filterState.filters.viewMode === 'export' && (
        <ExportTab queryParams={filterState.queryParams} />
      )}
    </Container>
  )
}

export default function V4Dashboard() {
  return (
    <DashboardQueryProvider>
      <V4DashboardContent />
    </DashboardQueryProvider>
  )
}
